import React from "react";

import ActionLink from "../../../components/admin/ActionLink";
import InfoCard from "../../../components/admin/InfoCard";
import PageIntro from "../../../components/admin/PageIntro";
import Pill from "../../../components/admin/Pill";
import SectionCard from "../../../components/admin/SectionCard";

export default function ServiceCategoriesPage() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      <PageIntro
        title="Service categories"
        description="Organize the HnB service taxonomy here. This area will support category structure, naming consistency, and downstream service classification across the platform."
      />

      <SectionCard
        eyebrow="Taxonomy management"
        title="Category structure is ready for backend seeding"
        description="Use this screen as the future workspace for service category records, parent-child grouping, and standardized naming across provider services and platform reporting."
      >
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          <Pill label="Service taxonomy" />
          <Pill label="Category hierarchy" />
          <Pill label="ERP expansion ready" />
        </div>
      </SectionCard>

      <section
        style={{
          background: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: "16px",
          padding: "28px",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            width: "56px",
            height: "56px",
            borderRadius: "14px",
            background: "#eef2ff",
            color: "#4338ca",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1.5rem",
            fontWeight: 700,
          }}
        >
          C
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <h2 style={{ margin: 0, fontSize: "1.15rem", color: "#111827" }}>
            No service categories yet
          </h2>

          <p style={{ margin: 0, color: "#6b7280", lineHeight: 1.6, maxWidth: "60ch" }}>
            Category records have not been seeded from the backend yet. Once data is
            available, this page can support category lists, hierarchy views, and
            service classification workflows for the wider HnB platform.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          <ActionLink to="/dashboard/providers" label="Review provider records" />
          <ActionLink
            to="/dashboard/platform-settings"
            label="Review platform settings"
          />
        </div>
      </section>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: "16px",
        }}
      >
        <InfoCard
          title="Planned records"
          body="This module can later display category names, internal codes, hierarchy position, and active status."
        />
        <InfoCard
          title="Planned actions"
          body="Future actions can include category creation, hierarchy edits, activation rules, and service-to-category mapping."
        />
        <InfoCard
          title="Why it matters"
          body="A clear taxonomy improves provider onboarding, service discovery, reporting consistency, and future ERP-scale structure."
        />
      </div>
    </div>
  );
}